export default __webpack_public_path__ + "static/media/keter.f88bcbe0.png";